import Immutable from 'immutable';

const initialState = Immutable.Map({
  errors: {},
});

function createStarted(state, payload) {
  state.setIn(['create', 'completed'], false);
  state.setIn(['create', 'failed'], false);
  state.setIn(['create', 'errors'], {});
  return state.set('loading', true);
}

function createCompleted(state, payload) {
  state.set('record', payload);
  state.setIn(['create', 'completed'], true);
  state.setIn(['create', 'failed'], false);
  state.setIn(['create', 'errors'], {});
  return state.set('loading', false);
}

function createFailed(state, payload) {
  state.setIn(['create', 'completed'], false);
  state.setIn(['create', 'failed'], true);
  state.setIn(
    ['create', 'errors'],
    payload && payload.errors ? payload.errors : {}
  );
  return state.set('loading', false);
}

function resetCreateState(state, payload) {
  state.setIn(['create', 'completed'], false);
  state.setIn(['create', 'failed'], false);
  return state.setIn(['create', 'errors'], {});
}

function updateStarted(state, payload) {
  state.setIn(['update', 'completed'], false);
  state.setIn(['update', 'failed'], false);
  state.setIn(['update', 'errors'], {});
  return state.set('loading', true);
}

function updateCompleted(state, payload) {
  state.set('record', payload);
  state.setIn(['update', 'completed'], true);
  state.setIn(['update', 'failed'], false);
  state.setIn(['update', 'errors'], {});
  return state.set('loading', false);
}

function resetUpdateState(state, payload) {
  state.setIn(['update', 'completed'], false);
  state.setIn(['update', 'failed'], false);
  state.setIn(['update', 'errors'], {});
  return state.set('loading', false);
}

function updateFailed(state, payload) {
  state.setIn(['update', 'completed'], false);
  state.setIn(['update', 'failed'], true);
  state.setIn(['update', 'errors'], payload.errors);
  return state.set('loading', false);
}

function notifyGuestStarted(state, payload) {
  state.setIn(['notifyGuest', 'completed'], false);
  state.setIn(['notifyGuest', 'failed'], false);
  return state.set('loading', true);
}

function notifyGuestCompleted(state, payload) {
  state.setIn(['notifyGuest', 'completed'], true);
  state.setIn(['notifyGuest', 'failed'], false);
  return state.set('loading', false);
}

function notifyGuestFailed(state, payload) {
  state.setIn(['notifyGuest', 'completed'], false);
  state.setIn(['notifyGuest', 'failed'], true);
  return state.set('loading', false);
}

function clearState(state, payload) {
  return state.clear();
}

function checkoutStarted(state, payload) {
  state.setIn(['checkout', 'completed'], false);
  state.setIn(['checkout', 'failed'], false);
  return state.set('loading', true);
}

function checkoutCompleted(state, payload) {
  state.set('record', payload);
  state.setIn(['checkout', 'completed'], true);
  state.setIn(['checkout', 'failed'], false);
  state.setIn(['checkout', 'errors'], {});
  return state.set('loading', false);
}

function checkoutFailed(state, payload) {
  state.setIn(['checkout', 'completed'], false);
  state.setIn(['checkout', 'failed'], true);
  state.setIn(['checkout', 'errors'], payload.errors);
  return state.set('loading', false);
}

function applyPromoCodeStarted(state, payload) {
  state.setIn(['applyPromoCode', 'completed'], false);
  state.setIn(['applyPromoCode', 'failed'], false);
  return state.set('loading', true);
}

function applyPromoCodeCompleted(state, payload) {
  state.set('record', payload);
  state.setIn(['applyPromoCode', 'completed'], true);
  state.setIn(['applyPromoCode', 'failed'], false);
  state.setIn(['applyPromoCode', 'errors'], {});
  return state.set('loading', false);
}

function applyPromoCodeFailed(state, payload) {
  state.setIn(['applyPromoCode', 'completed'], false);
  state.setIn(['applyPromoCode', 'failed'], true);
  state.setIn(['applyPromoCode', 'errors'], payload.errors);
  return state.set('loading', false);
}

function removePromoCodeStarted(state, payload) {
  state.setIn(['removePromoCode', 'completed'], false);
  state.setIn(['removePromoCode', 'failed'], false);
  return state.set('loading', true);
}

function removePromoCodeCompleted(state, payload) {
  state.set('record', payload);
  state.setIn(['applyPromoCode', 'completed'], false);
  state.setIn(['removePromoCode', 'completed'], true);
  state.setIn(['removePromoCode', 'failed'], false);
  state.setIn(['removePromoCode', 'errors'], {});
  return state.set('loading', false);
}

function removePromoCodeFailed(state, payload) {
  state.setIn(['removePromoCode', 'completed'], false);
  state.setIn(['removePromoCode', 'failed'], true);
  state.setIn(['removePromoCode', 'errors'], payload.errors);
  return state.set('loading', false);
}

function addStripeToken(state, token) {
  state.setIn(['stripe', 'stripeToken'], token);
  return state.set('loading', false);
}

function addStripe(state, stripeInstance) {
  state.setIn(['stripe', 'stripe'], stripeInstance);
  return state.set('loading', false);
}

function addCardElement(state, card) {
  state.setIn(['stripe', 'card'], card);
  return state.set('loading', false);
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        CUSTOM_BOOKING_CREATE: createStarted,
        CUSTOM_BOOKING_CREATE_COMPLETED: createCompleted,
        CUSTOM_BOOKING_CREATE_FAILED: createFailed,
        CUSTOM_BOOKING_RESET_CREATE_STATE: resetCreateState,
        CUSTOM_BOOKING_RESET_UPDATE_STATE: resetUpdateState,
        CUSTOM_BOOKING_UPDATE: updateStarted,
        CUSTOM_BOOKING_UPDATE_COMPLETED: updateCompleted,
        CUSTOM_BOOKING_UPDATE_FAILED: updateFailed,
        CUSTOM_BOOKING_CHECKOUT: checkoutStarted,
        CUSTOM_BOOKING_CHECKOUT_COMPLETED: checkoutCompleted,
        CUSTOM_BOOKING_CHECKOUT_FAILED: checkoutFailed,
        CUSTOM_BOOKING_NOTIFY_GUEST: notifyGuestStarted,
        CUSTOM_BOOKING_NOTIFY_GUEST_COMPLETED: notifyGuestCompleted,
        CUSTOM_BOOKING_NOTIFY_GUEST_FAILED: notifyGuestFailed,
        CUSTOM_BOOKING_CLEAR: clearState,
        CUSTOM_BOOKING_APPLY_PROMO_CODE: applyPromoCodeStarted,
        CUSTOM_BOOKING_APPLY_PROMO_CODE_COMPLETED: applyPromoCodeCompleted,
        CUSTOM_BOOKING_APPLY_PROMO_CODE_FAILED: applyPromoCodeFailed,
        CUSTOM_BOOKING_REMOVE_PROMO_CODE: removePromoCodeStarted,
        CUSTOM_BOOKING_REMOVE_PROMO_CODE_COMPLETED: removePromoCodeCompleted,
        CUSTOM_BOOKING_REMOVE_PROMO_CODE_FAILED: removePromoCodeFailed,
        CUSTOM_BOOKING_ADD_CARD_ELEMENT: addCardElement,
        CUSTOM_BOOKING_ADD_STRIPE_TOKEN: addStripeToken,
        CUSTOM_BOOKING_ADD_STRIPE: addStripe,
      }[type] || (() => state)
    )(state, payload);
  });
}
